// Shared grouping logic for the Account page's history tabs (JUDGING HISTORY and
// MY BOUTS) — both need the same event -> discipline drill-down shape over a flat
// list of bouts (each already carrying .eventId, as subscribeToUserJudgedBouts and
// subscribeToUserFighterBoutHistory both attach). The per-domain UI (drill-down
// state, breadcrumbs, card rendering, outcome derivation) stays duplicated in each
// tab's component — only this pure data shape is shared.

// bouts: flat list with .eventId attached; eventsById: { [eventId]: event }
export function groupBoutsByEvent(bouts, eventsById) {
  const map = new Map();
  for (const b of bouts) {
    if (!map.has(b.eventId)) map.set(b.eventId, []);
    map.get(b.eventId).push(b);
  }
  return [...map.entries()]
    .map(([eventId, evtBouts]) => ({
      eventId,
      event: eventsById[eventId],
      bouts: evtBouts,
      latest: Math.max(...evtBouts.map(b => b.createdAt?.seconds || 0)),
    }))
    .sort((a, b) => b.latest - a.latest);
}

// bouts: a single event's bout array
export function groupBoutsByDiscipline(bouts) {
  const map = new Map();
  for (const b of bouts) {
    const key = b.disciplineId || "__none__";
    if (!map.has(key)) map.set(key, { disciplineId: key, disciplineName: b.disciplineName || "Bouts", bouts: [] });
    map.get(key).bouts.push(b);
  }
  return [...map.values()];
}

// MY BOUTS only: one account's uid can be linked to more than one fighter name on the
// same event roster (e.g. a parent's two kids), so bouts within a single discipline can
// belong to different fighters. Groups by the private history entry's matched name so
// FighterBoutHistory can let the viewer pick a fighter before listing bouts, instead of
// interleaving two people's results under one list.
// bouts: a single discipline's (or non-tournament event's) bout array
export function groupBoutsByFighterName(bouts) {
  const map = new Map();
  for (const b of bouts) {
    const fighterNames = b._history?.fighterNames || [];
    const name = fighterNames.includes(b.fighterBlue) ? b.fighterBlue : b.fighterRed;
    if (!map.has(name)) map.set(name, { name, bouts: [] });
    map.get(name).bouts.push(b);
  }
  return [...map.values()].sort((a, b) => a.name.localeCompare(b.name));
}
